module.exports = __webpack_public_path__ + "image/Mud_Rage .png";